import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../reduxToolkit/hooks';
import { useGetStudentExamsQuery } from '../../../../reduxToolkit/reducers/usersSlice';
import CalendarContainer from '../../../applications/calendar';
import { createCalendarData } from '../../../../lib/utils';
import { CalendarData } from '../../../../types/Applications';
import { UserRole } from '../../../../types/Forms';

const StudentExamCalendarPageContainer = () => {
  const { id, role } = useAppSelector((state) => state.auth);
  const { data } = useGetStudentExamsQuery(id);
  const [calendarData, setCalendarData] = useState<CalendarData[]>([]);

  useEffect(() => {
    console.log('StudentExamCalendarPageContainer data', data)
    if (data && data.length > 0) {
      setCalendarData(createCalendarData(data));
    }
  }, [data]);
  return (
    <>
      <CalendarContainer calendarData={calendarData} role={role ?? UserRole.STUDENT} />
    </>
  );
};

export default StudentExamCalendarPageContainer;
